export default __webpack_public_path__ + "1e99e0100d91423c6abcf47a8269e45e.svg";